export default {
    "name": "SearchItinerary",
    "kind": "HoudiniQuery",
    "hash": "dd6ed48d62f9212887986167002233644055e8d9d1b7a0d5783fd76536458af5",

    "raw": `query SearchItinerary($input: SearchItineraryInput!) {
  searchItinerary(input: $input) {
    ... on SearchItinerarySuccessResult {
      __typename
      departureAddress {
        city
        country {
          code
          name
        }
        department
        region
        zipCode
      }
      arrivalAddress {
        city
        country {
          code
          name
        }
        department
        region
        zipCode
      }
      type
      routes {
        identifier
        legDistances
        isEv
        types
        summary
        routeDistance {
          value
          unit
        }
        duration
        trafficImpactDuration
        geometry
        fuelConsumption
        electricityConsumption
        energyCost {
          amount
          currency
        }
        costs {
          fuel {
            amount
            currency
          }
          tolls {
            amount
            currency
          }
          vignette {
            amount
            currency
          }
          electricity {
            amount
            currency
          }
        }
        totalCost {
          amount
          currency
        }
        carbonDioxideEmission
        vignettes {
          name
          message
          cost {
            amount
            currency
          }
        }
        tolls {
          name
          cost {
            amount
            currency
          }
        }
        evData {
          initialChargeLevel
          finalChargeLevel
          rechargePoints {
            coordinates {
              lat
              lng
            }
            distance {
              value
              unit
            }
          }
        }
        lezMentions {
          message
          url
          urlName
        }
        tracking {
          distance
          distanceType
          highwayDistance
          type
        }
        highwayDistance {
          value
          unit
        }
        highwayDuration
        roadsWithoutHighwayDistance {
          value
          unit
        }
        roadsWithoutHighwayDuration
        trafficMentions {
          geometry
          color
        }
        scenicDistance {
          value
          unit
        }
        trafficDeviation {
          title
          text
        }
      }
      waypoints {
        name
        location {
          lat
          lng
        }
        country
        city
      }
      arrivalZoi {
        zoiId
        name
        center {
          lng
          lat
        }
        radius
        polygon {
          type
          coordinates
        }
        images {
          ...ImageFragment
        }
        zoiImages {
          ...ImageFragment
        }
        containsEvStation
        description
      }
      adsTextLines {
        text
        ctaText
        ctaLink
        color
        advertiser
      }
      closingsMessage {
        text
      }
      departureCityPath
      arrivalCityPath
    }
    ... on SearchItineraryNotFoundResult {
      message
    }
    __typename
  }
}

fragment ImageFragment on Image {
  copyright
  w160
  w320
  w640
  w960
  w1280
  w1920
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "searchItinerary": {
                "type": "SearchItineraryResult",
                "keyRaw": "searchItinerary(input: $input)",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "SearchItinerarySuccessResult": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "departureAddress": {
                                    "type": "Address",
                                    "keyRaw": "departureAddress",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "country": {
                                                "type": "Country",
                                                "keyRaw": "country",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "code": {
                                                            "type": "String",
                                                            "keyRaw": "code",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "department": {
                                                "type": "String",
                                                "keyRaw": "department",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "region": {
                                                "type": "String",
                                                "keyRaw": "region",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "zipCode": {
                                                "type": "String",
                                                "keyRaw": "zipCode",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "arrivalAddress": {
                                    "type": "Address",
                                    "keyRaw": "arrivalAddress",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "country": {
                                                "type": "Country",
                                                "keyRaw": "country",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "code": {
                                                            "type": "String",
                                                            "keyRaw": "code",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "department": {
                                                "type": "String",
                                                "keyRaw": "department",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "region": {
                                                "type": "String",
                                                "keyRaw": "region",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "zipCode": {
                                                "type": "String",
                                                "keyRaw": "zipCode",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "type": {
                                    "type": "SearchItineraryResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "routes": {
                                    "type": "Route",
                                    "keyRaw": "routes",

                                    "selection": {
                                        "fields": {
                                            "identifier": {
                                                "type": "String",
                                                "keyRaw": "identifier",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "legDistances": {
                                                "type": "Float",
                                                "keyRaw": "legDistances",
                                                "visible": true
                                            },

                                            "isEv": {
                                                "type": "Boolean",
                                                "keyRaw": "isEv",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "types": {
                                                "type": "RouteType",
                                                "keyRaw": "types",
                                                "visible": true
                                            },

                                            "summary": {
                                                "type": "String",
                                                "keyRaw": "summary",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "routeDistance": {
                                                "type": "Distance",
                                                "keyRaw": "routeDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "duration": {
                                                "type": "Int",
                                                "keyRaw": "duration",
                                                "visible": true
                                            },

                                            "trafficImpactDuration": {
                                                "type": "Int",
                                                "keyRaw": "trafficImpactDuration",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "geometry": {
                                                "type": "String",
                                                "keyRaw": "geometry",
                                                "visible": true
                                            },

                                            "fuelConsumption": {
                                                "type": "Float",
                                                "keyRaw": "fuelConsumption",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "electricityConsumption": {
                                                "type": "Float",
                                                "keyRaw": "electricityConsumption",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "energyCost": {
                                                "type": "Price",
                                                "keyRaw": "energyCost",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "amount": {
                                                            "type": "Float",
                                                            "keyRaw": "amount",
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "costs": {
                                                "type": "RouteCosts",
                                                "keyRaw": "costs",

                                                "selection": {
                                                    "fields": {
                                                        "fuel": {
                                                            "type": "Price",
                                                            "keyRaw": "fuel",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "tolls": {
                                                            "type": "Price",
                                                            "keyRaw": "tolls",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "vignette": {
                                                            "type": "Price",
                                                            "keyRaw": "vignette",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "electricity": {
                                                            "type": "Price",
                                                            "keyRaw": "electricity",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "totalCost": {
                                                "type": "Price",
                                                "keyRaw": "totalCost",

                                                "selection": {
                                                    "fields": {
                                                        "amount": {
                                                            "type": "Float",
                                                            "keyRaw": "amount",
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "carbonDioxideEmission": {
                                                "type": "Float",
                                                "keyRaw": "carbonDioxideEmission",
                                                "visible": true
                                            },

                                            "vignettes": {
                                                "type": "RouteVignette",
                                                "keyRaw": "vignettes",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "message": {
                                                            "type": "String",
                                                            "keyRaw": "message",
                                                            "visible": true
                                                        },

                                                        "cost": {
                                                            "type": "Price",
                                                            "keyRaw": "cost",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "tolls": {
                                                "type": "RouteToll",
                                                "keyRaw": "tolls",

                                                "selection": {
                                                    "fields": {
                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "cost": {
                                                            "type": "Price",
                                                            "keyRaw": "cost",

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "evData": {
                                                "type": "EvData",
                                                "keyRaw": "evData",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "initialChargeLevel": {
                                                            "type": "Float",
                                                            "keyRaw": "initialChargeLevel",
                                                            "visible": true
                                                        },

                                                        "finalChargeLevel": {
                                                            "type": "Float",
                                                            "keyRaw": "finalChargeLevel",
                                                            "visible": true
                                                        },

                                                        "rechargePoints": {
                                                            "type": "RechargePointData",
                                                            "keyRaw": "rechargePoints",

                                                            "selection": {
                                                                "fields": {
                                                                    "coordinates": {
                                                                        "type": "Coordinates",
                                                                        "keyRaw": "coordinates",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "lat": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "lat",
                                                                                    "visible": true
                                                                                },

                                                                                "lng": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "lng",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    },

                                                                    "distance": {
                                                                        "type": "Distance",
                                                                        "keyRaw": "distance",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "value": {
                                                                                    "type": "Float",
                                                                                    "keyRaw": "value",
                                                                                    "visible": true
                                                                                },

                                                                                "unit": {
                                                                                    "type": "DistanceUnit",
                                                                                    "keyRaw": "unit",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "lezMentions": {
                                                "type": "RestrictedZoneMention",
                                                "keyRaw": "lezMentions",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "message": {
                                                            "type": "String",
                                                            "keyRaw": "message",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "url": {
                                                            "type": "String",
                                                            "keyRaw": "url",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "urlName": {
                                                            "type": "String",
                                                            "keyRaw": "urlName",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "tracking": {
                                                "type": "TrackingData",
                                                "keyRaw": "tracking",

                                                "selection": {
                                                    "fields": {
                                                        "distance": {
                                                            "type": "Float",
                                                            "keyRaw": "distance",
                                                            "visible": true
                                                        },

                                                        "distanceType": {
                                                            "type": "String",
                                                            "keyRaw": "distanceType",
                                                            "visible": true
                                                        },

                                                        "highwayDistance": {
                                                            "type": "Float",
                                                            "keyRaw": "highwayDistance",
                                                            "visible": true
                                                        },

                                                        "type": {
                                                            "type": "Int",
                                                            "keyRaw": "type",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "highwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "highwayDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "highwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "highwayDuration",
                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "roadsWithoutHighwayDistance",

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "roadsWithoutHighwayDuration",
                                                "visible": true
                                            },

                                            "trafficMentions": {
                                                "type": "RouteTrafficMention",
                                                "keyRaw": "trafficMentions",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "geometry": {
                                                            "type": "String",
                                                            "keyRaw": "geometry",
                                                            "visible": true
                                                        },

                                                        "color": {
                                                            "type": "RouteTrafficMentionColor",
                                                            "keyRaw": "color",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "scenicDistance": {
                                                "type": "Distance",
                                                "keyRaw": "scenicDistance",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "trafficDeviation": {
                                                "type": "TrafficDeviation",
                                                "keyRaw": "trafficDeviation",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "title": {
                                                            "type": "String",
                                                            "keyRaw": "title",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "text": {
                                                            "type": "String",
                                                            "keyRaw": "text",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "waypoints": {
                                    "type": "Waypoint",
                                    "keyRaw": "waypoints",

                                    "selection": {
                                        "fields": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "location": {
                                                "type": "Coordinates",
                                                "keyRaw": "location",

                                                "selection": {
                                                    "fields": {
                                                        "lat": {
                                                            "type": "Float",
                                                            "keyRaw": "lat",
                                                            "visible": true
                                                        },

                                                        "lng": {
                                                            "type": "Float",
                                                            "keyRaw": "lng",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "country": {
                                                "type": "String",
                                                "keyRaw": "country",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "arrivalZoi": {
                                    "type": "Zoi",
                                    "keyRaw": "arrivalZoi",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "zoiId": {
                                                "type": "String",
                                                "keyRaw": "zoiId",
                                                "visible": true
                                            },

                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "visible": true
                                            },

                                            "center": {
                                                "type": "Coordinates",
                                                "keyRaw": "center",

                                                "selection": {
                                                    "fields": {
                                                        "lng": {
                                                            "type": "Float",
                                                            "keyRaw": "lng",
                                                            "visible": true
                                                        },

                                                        "lat": {
                                                            "type": "Float",
                                                            "keyRaw": "lat",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "radius": {
                                                "type": "Float",
                                                "keyRaw": "radius",
                                                "visible": true
                                            },

                                            "polygon": {
                                                "type": "Polygon",
                                                "keyRaw": "polygon",

                                                "selection": {
                                                    "fields": {
                                                        "type": {
                                                            "type": "String",
                                                            "keyRaw": "type",
                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Float",
                                                            "keyRaw": "coordinates",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "images": {
                                                "type": "Image",
                                                "keyRaw": "images",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "copyright": {
                                                            "type": "String",
                                                            "keyRaw": "copyright",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "w160": {
                                                            "type": "String",
                                                            "keyRaw": "w160",
                                                            "visible": true
                                                        },

                                                        "w320": {
                                                            "type": "String",
                                                            "keyRaw": "w320",
                                                            "visible": true
                                                        },

                                                        "w640": {
                                                            "type": "String",
                                                            "keyRaw": "w640",
                                                            "visible": true
                                                        },

                                                        "w960": {
                                                            "type": "String",
                                                            "keyRaw": "w960",
                                                            "visible": true
                                                        },

                                                        "w1280": {
                                                            "type": "String",
                                                            "keyRaw": "w1280",
                                                            "visible": true
                                                        },

                                                        "w1920": {
                                                            "type": "String",
                                                            "keyRaw": "w1920",
                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    },

                                                    "fragments": {
                                                        "ImageFragment": {
                                                            "arguments": {}
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "zoiImages": {
                                                "type": "Image",
                                                "keyRaw": "zoiImages",

                                                "selection": {
                                                    "fields": {
                                                        "copyright": {
                                                            "type": "String",
                                                            "keyRaw": "copyright",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "w160": {
                                                            "type": "String",
                                                            "keyRaw": "w160",
                                                            "visible": true
                                                        },

                                                        "w320": {
                                                            "type": "String",
                                                            "keyRaw": "w320",
                                                            "visible": true
                                                        },

                                                        "w640": {
                                                            "type": "String",
                                                            "keyRaw": "w640",
                                                            "visible": true
                                                        },

                                                        "w960": {
                                                            "type": "String",
                                                            "keyRaw": "w960",
                                                            "visible": true
                                                        },

                                                        "w1280": {
                                                            "type": "String",
                                                            "keyRaw": "w1280",
                                                            "visible": true
                                                        },

                                                        "w1920": {
                                                            "type": "String",
                                                            "keyRaw": "w1920",
                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    },

                                                    "fragments": {
                                                        "ImageFragment": {
                                                            "arguments": {}
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "containsEvStation": {
                                                "type": "Boolean",
                                                "keyRaw": "containsEvStation",
                                                "visible": true
                                            },

                                            "description": {
                                                "type": "String",
                                                "keyRaw": "description",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "adsTextLines": {
                                    "type": "AdsTextLine",
                                    "keyRaw": "adsTextLines",

                                    "selection": {
                                        "fields": {
                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "visible": true
                                            },

                                            "ctaText": {
                                                "type": "String",
                                                "keyRaw": "ctaText",
                                                "visible": true
                                            },

                                            "ctaLink": {
                                                "type": "String",
                                                "keyRaw": "ctaLink",
                                                "visible": true
                                            },

                                            "color": {
                                                "type": "String",
                                                "keyRaw": "color",
                                                "visible": true
                                            },

                                            "advertiser": {
                                                "type": "String",
                                                "keyRaw": "advertiser",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "closingsMessage": {
                                    "type": "ClosingsMessage",
                                    "keyRaw": "closingsMessage",

                                    "selection": {
                                        "fields": {
                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "departureCityPath": {
                                    "type": "String",
                                    "keyRaw": "departureCityPath",
                                    "nullable": true,
                                    "visible": true
                                },

                                "arrivalCityPath": {
                                    "type": "String",
                                    "keyRaw": "arrivalCityPath",
                                    "nullable": true,
                                    "visible": true
                                }
                            },

                            "SearchItineraryNotFoundResult": {
                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "SearchItineraryInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "SearchItineraryInput": {
                "arrivalName": "String",
                "carId": "String",
                "constraint": "ItineraryConstraint",
                "coordinates": "CoordinatesInput",
                "currency": "Currency",
                "departureName": "String",
                "device": "Device",
                "distanceSystem": "DistanceSystem",
                "energyCost": "Float",
                "initialChargeLevel": "Float",
                "mode": "ItineraryTravelMode",
                "rechargeTreshold": "Float",
                "traffic": "ItineraryTrafficMode",
                "withCaravan": "Boolean",
                "withElectricVehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=3aa33d4b0bf73713d595a9abe7e27904daca809dcbe49c81d6e9c95afb07cd24";